import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UpdateTechnicianCalendarOrderDto } from '@myapp/contract'
import { technicianProfileKeys } from './keys'
import { technicianProfileApi } from './service'

/**
 * Saves the calendar order of the Handwerker.
 *
 * The order itself is read from `GET /schedule`, which this entity cannot invalidate (entities do
 * not import each other) — the caller refetches the schedule after it resolves.
 */
export function useUpdateTechnicianCalendarOrder() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (dto: UpdateTechnicianCalendarOrderDto) =>
      technicianProfileApi.updateCalendarOrder(dto).then(() => undefined),
    onSuccess: () => qc.invalidateQueries({ queryKey: technicianProfileKeys.all }),
  })
}
